<template>
  <div id="o-wrapper" class="h-100">
    <!-- route outlet -->
    <router-view></router-view>
    <div id="map"></div>
    <div id="popup" class="ol-popup">
      <a href="javascript:void(0);" id="popup-closer" class="ol-popup-closer"> <span aria-hidden="true">&times;</span> </a>
      <div id="popup-content"></div>
    </div>

    <Logo :items="items"></Logo>

    <Notifications :lastUpdate="lastUpdate" :notificationsCount="notificationsCount"></Notifications>

    <component :is="currentComponent" @create-overlay="createOverlay" v-if="$store.getters['map/getMap']"></component>

    <BottomNavBar ref="bottomNavBar" :menuItems="menuItems"></BottomNavBar>

    <!--    Don't touch these hidden icons this is for map font awesome icons    -->
    <i class="fa fa-times d-none"></i>
    <i class="fab fa-mixcloud d-none"></i>
    <i class="fad fa-bells d-none"></i>
  </div>
</template>

<script>
import Logo from "../components/Logo";
import BottomNavBar from "../components/map/BottomNavBar";
import World from "../components/map/World";
import Timeline from "@/components/map/Timeline.vue";
import Time from "../components/map/Time";
import Population from "@/components/map/Population.vue";
import Notifications from "../components/map/Notifications";

import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import {Tile as TileLayer} from 'ol/layer';
import {OSM} from 'ol/source';
import {fromLonLat, get as getProjection} from 'ol/proj';

import wol from "../assets/images/wol.png";
import time from "../assets/images/time.png";
import timeline from "../assets/images/timeline.png";
import population from "../assets/images/population.png";
import weather from "../assets/images/weather.png";
import {removeHashedIdFromURL} from "@/assets/js/utils";
import {mapState} from "@/assets/js/mapState";
import {NAV_ITEMS} from "@/utils/navItems";
import {buildMeta} from "@/utils/seo";

const menuItems = [
    {
        id: 1,
        title: "جهان",
        image: wol
    },
    {
        id: 2,
        title: "تایم‌لاین",
        image: timeline
    },
    {
        id: 3,
        title: "زمان",
        image: time
    },
    {
        id: 4,
        title: "جمعیت",
        image: population
    },
    {
        id: 5,
        title: "هوا",
        image: weather
    }
];

export default {
    name: 'Map',
    metaInfo() {
        return buildMeta({
            title: "نقشه زنده اخبار جهان | لایوی",
            description: "رویدادها و اخبار زنده جهان را به صورت لحظه‌ای روی نقشه تعاملی لایوی ببینید و دنبال کنید.",
            path: "/map",
            type: "website",
        });
    },
    components: {
        Logo,
        BottomNavBar,
        Notifications,
        World,
        Timeline,
        Time,
        Population
    },
    data() {
        return {
            lastUpdate: '',
            notificationsCount: 0,
            toastsQueue: [],
            items: NAV_ITEMS,
            menuItems: menuItems,
            currentMenuId: 1
        };
    },
    computed: {
        currentComponent() {
            switch (this.currentMenuId) {
                case 1: return 'World';
                case 2: return 'Timeline';
                case 3: return 'Time';
                case 4: return 'Population';
                default: return null;
            }
        }
    },
    created() {
        this.$store.registerModule('map', {
            namespaced: true,
            state: () => ({ map: null }),
            mutations: {
                setMap(state, map) {
                    state.map = map;
                },
                removeMap(state) {
                    if (state.map && typeof state.map.setTarget === 'function') {
                        state.map.setTarget(null);
                    }
                    state.map = null;
                }
            },
            getters: {
                getMap: state => state.map
            }
        });
    },
    mounted() {
        let categoryId = this.$route.params.category_id;
        if (categoryId !== undefined) {
            const checkCategoryId = Number(categoryId);
            // Disable categories
            if (checkCategoryId > 4) {
                categoryId = undefined;
                this.fixUrlByCategoryId(checkCategoryId);
            }
        }
        if (categoryId !== undefined) {
            this.currentMenuId = Number(categoryId);
            this.$nextTick(() => {
                this.$refs.bottomNavBar.changeCategory(this.currentMenuId);
            });
        }
        this.initMapByCategoryId(this.currentMenuId);
    },
    methods: {
        initMap(center, zoom) {
            this.$store.commit('map/removeMap');
            const map = new Map({
                target: 'map',
                view: new View({
                    center: fromLonLat(center),
                    zoom: zoom,
                    projection: 'EPSG:3857',
                    extent: getProjection('EPSG:3857').getExtent(),
                    enableRotation: false
                })
            });
            const raster = new TileLayer({
                source: new OSM({
                    url: 'https://basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png?key=cb1_2kl4_1_9dd897cb09972421e3b732b3',
                }),
            });
            map.addLayer(raster);
            map.on('pointermove', function (e) {
                const feature = map.forEachFeatureAtPixel(e.pixel, f => f);
                $('body').css('cursor', feature && feature.get('selectable') !== false ? 'pointer' : 'auto');
            });
            this.$store.commit('map/setMap', map);
        },
        initMapByCategoryId(id) {
            let zoom;
            const screenWidth = window.innerWidth;
            if (screenWidth < 768) {
                zoom = 4.5;
            } else if (screenWidth < 1200) {
                zoom = 5;
            } else {
                zoom = 4;
            }
            if (id === 3 || id === 4) {
                zoom = zoom - 2;
            }
            this.initMap([53.34960937499999, 32.472695022061515], zoom);
        },
        fixUrlByCategoryId(id) {
            const targetPath = (id === 1 || id > 4) ? `/map` : `/map/category/${id}`;
            if (this.$route.path === targetPath) {
                return;
            }
            this.$router.push({ path: targetPath });
        },
        createOverlay(width) {
            const container = document.getElementById('popup');
            const content = document.getElementById('popup-content');
            const closer = document.getElementById('popup-closer');

            if (!container || !closer) return null;

            mapState.container = container;
            mapState.content = content;
            mapState.closer = closer;

            container.style.width = width;

            closer.onclick = function () {
                mapState.overlay.setPosition(undefined);
                // Clear select when cluster popup open
                const features = container.querySelectorAll('.message');
                if (features.length > 1) {
                    mapState.selectCluster.clear();
                } else {
                    const selected = mapState.selectCluster.getFeatures().getArray()[0];
                    if (selected) {
                        mapState.selectCluster.getFeatures().remove(selected);
                    }
                }

                removeHashedIdFromURL();

                return false;
            };

            return container;
        },
    },
    beforeDestroy() {
        if (this.$store.hasModule('map')) {
            this.$store.unregisterModule('map');
        }
    }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/css/tokens";

  #map {
    direction: ltr !important;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 0;
  }

  /* OpenLayers popup — restyled to match the marketing/blog card aesthetic. */
  .ol-popup {
    position: absolute;
    bottom: 12px;
    transform: translateX(-50%);
    display: none;
    text-align: right;
    background: $bg-card;
    border: 1px solid $border-light;
    border-radius: 16px;
    box-shadow: 0 12px 30px rgba($accent-blue, 0.10), 0 2px 8px rgba(0, 0, 0, 0.05);
    overflow: hidden;

    /* Gradient top accent replaces the old solid purple stripe. */
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background: $gradient-main;
    }
  }

  /* Pointer triangle below the popup. */
  .ol-popup:before {
    content: " ";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: solid transparent;
    border-top-color: $bg-card;
    border-width: 10px;
    height: 0;
    width: 0;
    pointer-events: none;
    filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 0.06));
  }

  .ol-popup-closer {
    position: absolute;
    top: 8px;
    right: 14px;
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    font-size: 18px;
    line-height: 1;
    color: $text-muted;
    text-decoration: none !important;
    cursor: pointer !important;
    z-index: 55555;
    transition: background 0.2s ease, color 0.2s ease;

    &:hover {
      color: $accent-blue;
      background: rgba($accent-blue, 0.08);
    }
  }

  #popup-content {
    max-height: 50vh;
    overflow-y: auto;
    padding-top: 4px;
  }
</style>
